import { PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './my-site-home-app.html';
import {MySiteRestService} from '@nuskin/my-site-api';
import {RunConfigService, SponsorStorageService, ShoppingContext} from '@nuskin/ns-util';

import '@polymer/app-route/app-location.js';
import '@polymer/app-route/app-route.js';
import '@polymer/iron-pages/iron-pages.js';
import { PriceType } from '@nuskin/ns-shop';

/**
 * MySiteHomeApp provides the My Site store home page view.
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <my-site-home subdomain="andrea1"
 *          properties="{\"tdc_helloText\": \"Hello! My name is {name}\",
 *              \"tdc_welcomeToStore\": \"Welcome to my test page!\",
 *              \"tdc_defaultWelcomeMsg\": \"Lorem ipsum dolor sit amet, \",
 *              \"avatarImageReference\": \"https://firebasestorage.googleapis.com/v0/b/testpitch-f0a71.appspot.com/o/profilePic%2Fbharatmat_b5a4a0e192a0a8aebc7245990e2c4855.jpeg?alt=media&token=c723373b-fffd-4023-9d32-ff9a4e6c9ee3\",\"tdc_featuredProductsTitle\": \"Featured Products\",\"tdc_featuredProductsDescription\": \"These products are featured\",
 *              \"tdc_featuredProductsLinkText\": \"View all\",\"featuredProductsLinkPath\": \"#\",\"productDetailPath\": \"#\",\"tdc_productNotAvailable\": \"Item Not Available\",\"tdc_itemLabel\": \"Item\",\"tdc_priceLabel\": \"Price\",
 *               \"tdc_qtyLabel\": \"Quantity\",\"tdc_purchaseLabel\": \"Add to Bag\",\"tdc_pointsLabel\": \"Points\",\"tdc_variantSelectLabel\": \"Select Variant:\",\"tdc_quickShopLabel\": \"Go fast\",\"tdc_featuredBundleTitle\": \"Better Together\",\"tdc_defaultBundlesMessage\": \"These products go great together!\",\"tdc_featuredBundleItemsLabel\": \"{qty} items\",\"tdc_featuredBundleAddItemsLabel\": \"Add to Bag\"}"></my-site-home>
 *   </template>
 * </demo-snippet>
 *
 * @customElement
 * @polymer
 */
class MySiteHomeApp extends PolymerElement {
    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            /**
             * Localized strings and url paths needed by the app and its child elements.
             * This object is matched to the config data provided by the mySiteHomeWrapper AEM component.
             * @type Object
             */
            properties: {
                type: Object,
                value: {
                    'tdc_helloText': 'Hello! My name is {name}',
                    'tdc_welcomeToStore': 'Welcome to my store',
                    'tdc_defaultWelcomeMsg': 'Placeholder Welcome Message',
                    'avatarImageReference': '',
                    'tdc_featuredProductsTitle': 'Featured Products',
                    'tdc_featuredProductsDescription': 'Placeholder ',
                    'tdc_featuredProductsLinkText': 'View All',
                    'featuredProductsLinkPath': '#',
                    'productDetailPath': '',
                    'tdc_productNotAvailable': 'Not Available for Purchase',
                    'tdc_itemLabel': 'Item',
                    'tdc_priceLabel': 'Price',
                    'tdc_qtyLabel': 'Quantity',
                    'tdc_purchaseLabel': 'Add to Bag',
                    'tdc_chooseLabel': 'Choose {variant}',
                    'tdc_pointsLabel': 'Points',
                    'tdc_variantSelectLabel': 'Choose Variant:',
                    'tdc_quickShopLabel': 'Quick Buy',
                    'tdc_featuredBundleTitle': 'Better Together',
                    'tdc_defaultBundlesMessage': '',
                    'tdc_featuredBundleItemsLabel': '{qty} items',
                    'tdc_featuredBundleAddItemsLabel': 'Add to Cart',
                    'tdc_backToHomeLabel': 'Back'
                }
            },
            /**
             * Subdomain override; setting this property causes the app to ignore the current subdomain and stored sponsor (if any),
             * and to initialize with the My Site store of the given subdomain. This property is primarily intended for testing and
             * demo purposes.
             * @type String
             */
            subdomain: {
                type: String,
                value: '',
                observer: '_overrideSubdomain'
            },
            /**
             * Data-Bound property from ns-storefront-featured-products. Using as a counter to ensure all necessary events have fired
             * that are needed
             * for the subscribe of nsProductSmallImpressionData event.
             * @type Number
             */
            searchResultsNumber: {
                type: Number,
                notify: true
            },
            _sponsor: {
                type: Object,
                value: {}
            },
            _banner: {
                type: Object,
                value: {
                    titleText: '',
                    bodyText: '',
                    imageUrls: {}
                }
            },
            _hideBanner: {
                type: Boolean,
                value: false
            },
            _bannerTranslations: {
                type: Object,
                value: {}
            },
            _messages: {
                type: Object,
                value: {'welcomeMessage': ''}
            },
            _featuredProducts: {
                type: Array,
                value: []
            },
            _featuredBundle: {
                type: Array,
                value: []
            },
            _productSmallTranslations: {
                type: Object,
                value: {
                    'notAvailable': 'Not Available for Purchase',
                    'item': 'Item',
                    'price': 'PRICE',
                    'qty': 'QUANTITY',
                    'purchase': 'ADD TO BAG',
                    'choose': 'Choose ',
                    'select': 'Select',
                    'points': 'Points',
                    'variantSelect': 'Select Variant:',
                    'quickShop': 'Quick Shop'
                }
            },
            _bundleTranslations: {
                type: Object,
                value: {
                    'title': '',
                    'customBundleMessage': '',
                    'defaultBundleMessage': '',
                    'items': '',
                    'addItemsToCart': ''
                }
            },
            _useCustomBundleMsg: {
                type: Boolean,
                value: false
            },
            showMySiteCategories: {
                type: Boolean,
                value: false
            },
            priceType: String
        };
    }

    static get observers() {
        return ['_viewChanged(routeData.view)'];
    }

    async ready() {
        super.ready();
        //ShoppingContext.setShoppingContext('storefront');
        // DTS-216
        try {
            document.body.style.overflow = 'unset';
            document.getElementById('mainWrapper').style.overflow = 'unset';
        } catch(err){
            console.log(err)
        }

        // If subdomain is overridden, skip normal initialization
        if (this.subdomain) return;

        let subdomain = await MySiteRestService.getCurrentSubdomain();
        MySiteRestService.getCurrentSponsorId()
            .then(sponsorId => this._initMySite(sponsorId, subdomain))
            .catch(console.error);

        // COM-3097: ProductImpression on page load Event for mySite
        this.productSmallImpressions = [];
        // eslint-disable-next-line
        this.currencyCode = aem.CurrencyService.getCurrency(RunConfigService.getRunConfig().country).currencyCode;
        // eslint-disable-next-line
        $.subscribe('nsProductSmallImpressionData', (e) => {
            this.productSmallImpressions.push(e.detail);
            // Wait to fire Impression Event until impression data has returned from all ns-product-small
            if (this.searchResultsNumber !== 0 
                && this.productSmallImpressions.length === this._featuredBundle.length + this._featuredProducts.length + this.searchResultsNumber) {
                this._fireImpressionEvent();
            }
        });
    }

    _overrideSubdomain() {
        if (!this.subdomain) return;

        console.log(`Overriding My Site subdomain with ${this.subdomain}`);

        let id = MySiteRestService.getCurrentSponsorId()    
        // Override stored sponsor ID
        SponsorStorageService.setSponsor(id);
        return this._initMySite(id)
    }

    async _getSponsor() {
        let sponsorId = await MySiteRestService.getCurrentSponsorId();
        await this._initMySite(sponsorId);
    }

    async _initMySite(sponsorId) {
        // If no sponsor ID provided, abort initialization
        if (!sponsorId) return;
        
        let runCfg = RunConfigService.getRunConfig()

        let country = runCfg.country;
        let language = runCfg.language;
        let sponsor = await MySiteRestService.getSponsorData(sponsorId);
        let contextOptions
        let subdomain

        if(!sponsor) {
            subdomain = await MySiteRestService.getCurrentSubdomain();
            subdomain = subdomain || 'user-'+new Date().getTime()
            sponsor = {
                storefront: {}
            };
            sponsor.storefront[subdomain] = {}
            sponsor.storefront[subdomain][runCfg.country] = {}
            sponsor.storefront[subdomain][runCfg.country].lang = {}
            sponsor.storefront[subdomain][runCfg.country].lang[runCfg.language] = {}
        }

        if(sponsor && !sponsor.storefront) {
            subdomain = await MySiteRestService.getCurrentSubdomain();
            subdomain = subdomain || 'user-'+new Date().getTime()
            sponsor.storefront = {}
            sponsor.storefront[subdomain] = {}
        }

        // Disregard what subdomain was provided in the url 
        // and rely only on the subdomain associated with sponsorId
        let store;
        if(sponsor && sponsor.storefront) {
            subdomain = Object.keys(sponsor.storefront)[0];
            store = sponsor.storefront[subdomain][country];
        }

        if(!store || (store && !store.lang)) {
            let banners = await MySiteRestService.getMarketBanners(country, language);
            store = {
                showDefaultBundles: true,
                showDefaultProducts: true,
                lang: {}
            }
            store.lang[language] = {
                banner: banners[0]
            }

        }

        let sponsorIsWholesale = sponsor.storefront[subdomain][runCfg.country] 
            && sponsor.storefront[subdomain][runCfg.country].lang 
            && sponsor.storefront[subdomain][runCfg.country].lang[runCfg.language]
            ? !!sponsor.storefront[subdomain][runCfg.country].lang[runCfg.language].wholesale
            : false

        this.set('priceType', sponsorIsWholesale ? PriceType.WWHL : null)

        contextOptions = {
            showWholeSalePricing: sponsorIsWholesale
        }
        
        if(sponsorIsWholesale) {
            contextOptions.allowAnonymousShopping = false
            contextOptions.preferredSignupOnly = true
        } else {
            contextOptions.allowAnonymousShopping = true
            contextOptions.preferredSignupOnly = false
        }

        ShoppingContext.setShoppingContext('storefront', contextOptions);

        this._initSponsor(sponsor || {});
        await this._initStore(store);
    }

    _initSponsor(sponsor) {
        this.set('_sponsor', sponsor || {});
    }

    async _initStore(store) {
        let runCfg = RunConfigService.getRunConfig();
        // Set store name
        let storeName = (!store.lang || !store.lang[runCfg.language] || !store.lang[runCfg.language].storeName) 
            ? this.properties['tdc_welcomeSectionSiteName']
            : store.lang[runCfg.language].storeName;

        let aboutYourStore = (!store.lang || !store.lang[runCfg.language] || !store.lang[runCfg.language].aboutYourStore) 
            ? this.properties['tdc_welcomeSectionAboutYourSite']
            : store.lang[runCfg.language].aboutYourStore;

        this.set('_storeName', storeName);
        this.set('_aboutYourStore', aboutYourStore);

        let banner = (!store.lang || !store.lang[runCfg.language]) ? null : store.lang[runCfg.language].banner;

        // get default market banner
        if(banner === null && store.lang) {
            let firstLangNode = Object.keys(store.lang)[0]
            if(firstLangNode && store.lang[firstLangNode].banner) {
                let banners = await MySiteRestService.getMarketBanners(runCfg.country, runCfg.language)
                banner = banners[0] || '';
            }
        }

        store.lang = store.lang || {};

        store.lang[runCfg.language] = store.lang[runCfg.language] || {};
        
        // refresh default bundles
        if(store.showDefaultBundles) {
            store.bundles = [
                {
                    id: 0,
                    skus: await MySiteRestService.getMarketFeaturedBundle(runCfg.country)
                }
            ];

            store.lang[runCfg.language].bundlesInfo = [
                {
                    bundle_id: 0,
                    name: this.properties['tdc_featuredBundleTitle'],
                    about: this.properties['tdc_defaultBundlesMessage']
                }
            ]
        }
        // refresh featured products
        if(store.showDefaultProducts) {
            let products = await MySiteRestService.getMarketFeaturedProducts() || [];
            store.products = products.map(item => item.sku);
        }

        // Fallback to hiding banner element if no banner is provided
        if (!banner) {
            this.set('_hideBanner', true);
        } else {
            // handle legacy data with country and language hardcoded in CTA as well the case where provided url is not language/market specific
            let urlParts = banner.ctaLink.split(/\/?content\/nuskin\/[a-z][a-z]_[A-Z][A-Z]/g);
            if(urlParts.length) {
                let runCfg = RunConfigService.getRunConfig();
                let ln_ctry = `${runCfg.language}_${runCfg.country}`;
                let urlPart = urlParts[urlParts.length-1];
                banner.ctaLink = `/content/nuskin/${ln_ctry}${urlPart}`;
                
            } 
            let subdomain = await MySiteRestService.getCurrentSubdomain()
            banner.ctaLink = banner.ctaLink.replace('.mysite.', `.mysite.${subdomain}.`)
            this.set('_banner', banner);
            this.set('_bannerTranslations', {ctaCopy: banner.ctaText});
        }

        // Initialize app routing
        this.set('basePath', window.location.pathname);
        this.set('fullUrl',window.location.href)
        if (this.routeData && !this.routeData.view) {
            // Default to home view
            this.set('route.path', 'home');
        }
        // Initialize localized messages
        let language = RunConfigService.getRunConfig().language;
        this._initMessages(store.lang[language]);

        // Initialize featured products and bundle
        await this._initFeaturedProducts(store);
        await this._initFeaturedBundle(store);
    }

    _initMessages(messages = {}) {
        // Fallback to default welcome message if needed
        messages.welcomeMessage = messages.welcomeMessage || this.properties['tdc_defaultWelcomeMsg'];
        this.set('_messages', messages);

        // Set strings for ns-product-bundle component
        let bundleTranslations = {
            'title': this.properties['tdc_featuredBundleTitle'],
            'defaultBundleMessage': this.properties['tdc_defaultBundlesMessage'],
            'items': this.properties['tdc_featuredBundleItemsLabel'],
            'addItemsToCart': this.properties['tdc_featuredBundleAddItemsLabel']
        };
        this.set('_bundleTranslations', bundleTranslations);

        // Set strings for ns-product-small component
        let productTranslations = {
            'notAvailable': this.properties['tdc_productNotAvailable'],
            'item': this.properties['tdc_itemLabel'],
            'price': this.properties['tdc_priceLabel'],
            'qty': this.properties['tdc_qtyLabel'],
            'purchase': this.properties['tdc_purchaseLabel'],
            'choose': this.properties['tdc_chooseLabel'],
            'points': this.properties['tdc_pointsLabel'],
            'variantSelect': this.properties['tdc_variantSelectLabel'],
            'quickShop': this.properties['tdc_quickShopLabel']
        };
        this.set('_productSmallTranslations', productTranslations);

        // Set strings for ns-storefront-featured-products
        let featuredPageTranslations = {
            title: this.properties['tdc_featuredProductsPageTitle'],
            loadMore: this.properties['tdc_loadMore'],
            sortBy: this.properties['tdc_sortBy'],
            notAvailable: this.properties['tdc_productNotAvailable'],
            psv: 'PSV'
        };
        featuredPageTranslations = Object.assign(featuredPageTranslations, productTranslations);
        this.set('_featuredProductsPageTranslations', featuredPageTranslations);
        this.set('_featuredProductsPageSort', this.properties['sortOptions']);
    }

    async _initFeaturedProducts(store) {
        if (!store.products) {
            // Show market's default featured products
            let products = await MySiteRestService.getMarketFeaturedProducts();
            store.products = products.map(p => p.sku);
        }

        let runCfg = RunConfigService.getRunConfig();
        let aboutProducts;
        
        if(store && store.lang[runCfg.language] && store.lang[runCfg.language].aboutProducts)
            aboutProducts = store.lang[runCfg.language].aboutProducts;
        else
            aboutProducts = this.properties.tdc_featuredProductsDescription;
 
        this.set('aboutProducts', aboutProducts);
        this.set('_featuredProducts', store.products.slice(0, 3));
    }

    async _initFeaturedBundle(store) {
        let runCfg = RunConfigService.getRunConfig();
        let bundles;
        if (store && store.bundles) {
            // Show store's own featured bundle
            bundles = store.bundles;
        } else {
            // Show market's default featured bundle
            bundles = await MySiteRestService.getMarketFeaturedBundle()
        }
        this.set('_bundles', bundles);
        let lang = store.lang[runCfg.language];
        let bundlesInfo;
        if(lang) {
            bundlesInfo = lang.bundlesInfo
        } else {
            bundlesInfo = [{
                bundle_id: 0,
                name: this.properties['tdc_featuredBundleTitle'] || '',
                about: this.properties['tdc_defaultBundlesMessage'] || ''
            }];

            let banners = await MySiteRestService.getMarketBanners(runCfg.country, runCfg.language);
            this.set('_banner', banners[0]);
            this._hideBanner = false;
        }
        this.set('_bundlesInfo', bundlesInfo);
    }

    _getPdpUrl(sku) {
        return `${this.properties['productDetailPath']}.${sku}.mysite.html`;
    }

    _viewChanged(view) {
        this.set('view', view);
        this._fireImpressionEvent();
    }

    /**
     * COM-3097
     * Fires on Page Load and on switching view between #home, and #products.
     * Filters and creates the product impression array based on components view and
     * publishes new productImpression event when done.
     */
    _fireImpressionEvent() {
        const hasProductSmallImpressionArray = this.productSmallImpressions && this.productSmallImpressions.length > 0;
        if (this.view === 'home'
            && hasProductSmallImpressionArray
            && this.productSmallImpressions.filter(p => p.sku).length === this._featuredProducts.length + this._featuredBundle.length) {
            const homeViewImpressions = this.productSmallImpressions.filter(p => p.sku).map((item, index) => {
                return {
                    "id": item.product.sku,
                    "name": item.product.title,
                    "price": item.price,
                    "position": index
                };
            });
            this._publishProductImpressionEvent(homeViewImpressions);
        } else if (this.view === 'products'
            && hasProductSmallImpressionArray
            && this.productSmallImpressions.filter(p => !p.sku).length === this.searchResultsNumber) {
            const productViewImpressions = this.productSmallImpressions.filter(p => !p.sku).map((item, index) => {
                return {
                    "id": item.product.sku,
                    "name": item.product.title,
                    "price": item.price,
                    "position": index
                };
            });
            this._publishProductImpressionEvent(productViewImpressions);
        } else if (this.view === "categories") {
            console.log("Categories")

        }
    }

    /**
     * COM-3097
     * Builds and Fires the productImpression event
     * @param {*} impressionEventObject
     */
    _publishProductImpressionEvent(impressionEventObject) {
        // eslint-disable-next-line
        $.publish('productImpression', {
            'ecommerce': {
                'currencyCode': this.currencyCode,
                'impressions': impressionEventObject
            }
        });
    }


}

window.customElements.define('my-site-home-app', MySiteHomeApp);
